import { toast } from "react-toastify";
import { API_DEVOLUCION_MERCANCIAS } from "../views/MainLayout/components/shared/services/devoluciones_mercancias";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialDevolucionMercancias = []

export const devolucionesMercanciasReducer = (state = initialDevolucionMercancias, action) => {
    switch(action.type){
        case "devolucion_mercancias/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchDevolucionesMercancias = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_DEVOLUCION_MERCANCIAS.getDevolucionesMercancias(page, search)
        const data = await response.data;
        dispatch({ type: 'devolucion_mercancias/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}